export const GC_USER_ID = "graphcool-user-id";
export const GC_USER_TYPE = "graphcool-user-type";
export const GC_AUTH_TOKEN = "graphcool-auth-token";
export const LANG = "lang";
export const DRAFT_EMPLOYEE = "draft-employee";
export const DRAFT_TRAINING = "draft-training";
export const GC_AUTH_TOKEN_EXPIRES_IN = "graphcool-auth-token-expires-in";
